<template>
  <section class="views">
    <!-- header -->
    <headers select="2"></headers>

    <!-- banner  -->
    <div class="posters">
      <van-image
        width="100%"
        :src="
          require(`@/assets/image/hodgepodge/pcbanner_${this.$i18n.locale}.jpg`)
        "
      />
      <div class="posters_ewm" v-if="false">
        <div class="ewm">
          <div class="ewm2">
            <div class="ewm3">
              <img :src="require('@/assets/image/csewm.png')" alt="" />
            </div>
            <div class="ewm3_value">掃碼報名比賽</div>
          </div>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="viewsBoxTab">
        <div class="viewsTab">
          <ul>
            <li
              v-for="(item, index) in gradeColumns"
              :key="index"
              @click="tabBut(index)"
              :class="select === index ? 'select' : ''"
            >
              <div>{{ item.name }}</div>
              <div>({{ item.fzhu }})</div>
            </li>
          </ul>
        </div>
      </div>

      <div class="viewsList">
        <ul class="animate__animated animate__bounceInLeft" v-if="select === 0">
          <li
            v-for="(item, index) in pdfList"
            :key="index"
            @click="pdfBut(item)"
          >
            {{ item.name }}
          </li>
          <!-- <div class="viewBoxContent">
            <div class="box_uls">
              <div class="box_title">
                <img
                  :src="require('@/assets/image/homeTitle/title_img.png')"
                  alt=""
                />
                <div class="title">
                  {{ $t("home.Match_schedule.competition_groups.video_demo") }}
                </div>
              </div>
              <div class="container">
                <div class="item" v-for="(item, index) in videoList_A" :key="item.id">
                  <div class="item_title">
                    {{ item.title }}
                  </div>
                  <video controls width="640" style="display: block; margin: auto;">
                    <source :src="item.url" type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
          </div> -->
        </ul>

        <ul class="animate__animated animate__bounceInLeft" v-if="select === 1">
          <li
            v-for="(item, index) in pdfList"
            :key="index"
            @click="pdfBut(item)"
          >
            {{ item.name }}
          </li>
          
          <!-- <div class="viewBoxContent">
            <div class="box_uls">
              <div class="box_title">
                <img
                  :src="require('@/assets/image/homeTitle/title_img.png')"
                  alt=""
                />
                <div class="title">
                  {{ $t("home.Match_schedule.competition_groups.video_demo") }}
                </div>
              </div>
              <div class="container">
                <div class="item" v-for="(item, index) in videoList_B" :key="item.id">
                  <div class="item_title">
                    {{ item.title }}
                  </div>
                  <video controls width="640" style="display: block; margin: auto;">
                    <source :src="item.url" type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
          </div> -->
        </ul>
        <ul class="animate__animated animate__bounceInLeft" v-if="select === 2">
          <li
            v-for="(item, index) in pdfList"
            :key="index"
            @click="pdfBut(item)"
          >
            {{ item.name }}
          </li>
          
          <!-- <div class="viewBoxContent">
            <div class="box_uls">
              <div class="box_title">
                <img
                  :src="require('@/assets/image/homeTitle/title_img.png')"
                  alt=""
                />
                <div class="title">
                  {{ $t("home.Match_schedule.competition_groups.video_demo") }}
                </div>
              </div>
              <div class="container">
                <div class="item" v-for="(item) in videoList_C" :key="item.id">
                  <div class="item_title">
                    {{ item.title }}
                  </div>
                  <video controls width="640" style="display: block; margin: auto;">
                    <source :src="item.url" type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
          </div> -->
        </ul>
        <ul class="animate__animated animate__bounceInLeft" v-if="select === 3">
          <li
            v-for="(item, index) in pdfList"
            :key="index"
            @click="pdfBut(item)"
          >
            {{ item.name }}
          </li>
        </ul>
        <ul class="animate__animated animate__bounceInLeft" v-if="select === 4">
          <li
            v-for="(item, index) in pdfList"
            :key="index"
            @click="pdfBut(item)"
          >
            {{ item.name }}
          </li>
        </ul>
        <ul class="animate__animated animate__bounceInLeft" v-if="select === 5">
          <li
            v-for="(item, index) in pdfList"
            :key="index"
            @click="pdfBut(item)"
          >
            {{ item.name }}
          </li>
        </ul>
        <ul class="animate__animated animate__bounceInLeft" v-if="select === 6">
          <li
            v-for="(item, index) in pdfList"
            :key="index"
            @click="pdfBut(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import headers from "@/components/header/pc_header";
export default {
  name: "signup",
  data() {
    return {
      anshow: true,
      gradeColumns: [
        {
          name: this.$t("home.Match_schedule.competition_groups.group_a_text"),
          fzhu: this.$t("home.Match_schedule.competition_groups.group_a_age"),
        },
        {
          name: this.$t("home.Match_schedule.competition_groups.group_b_text"),
          fzhu: this.$t("home.Match_schedule.competition_groups.group_b_age"),
        },
        {
          name: this.$t("home.Match_schedule.competition_groups.group_c_text"),
          fzhu: this.$t("home.Match_schedule.competition_groups.group_c_age"),
        },
      ],
      pdf: {
        new0: [
          // {
          //   name: this.$t(
          //     "home.Match_schedule.competition_groups.introduction"
          //   ),
          //   url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/image/ba9d204afe1986b1000a45cabfda0ff7.pdf",
          // },
          {
            name: this.$t("home.Match_schedule.competition_groups.download"),
            url: "https://chineserd-audio-1256597606.cos.accelerate.myqcloud.com/readingcontest/id/eda8e3ffd8ce10b372bb49ddd52291fd.pdf",
          },
        ],
        new1: [
          // {
          //   name: this.$t(
          //     "home.Match_schedule.competition_groups.introduction"
          //   ),
          //   url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/image/ba9d204afe1986b1000a45cabfda0ff7.pdf",
          // },
          {
            name: this.$t("home.Match_schedule.competition_groups.download"),
            url: "https://chineserd-audio-1256597606.cos.accelerate.myqcloud.com/readingcontest/id/b85819ebd229ed3fd3f45034e2db6a9e.pdf",
          },
        ],
        new2: [
          // {
          //   name: this.$t(
          //     "home.Match_schedule.competition_groups.introduction"
          //   ),
          //   url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/image/ba9d204afe1986b1000a45cabfda0ff7.pdf",
          // },
          {
            name: this.$t("home.Match_schedule.competition_groups.download"),
            url: "https://chineserd-audio-1256597606.cos.accelerate.myqcloud.com/readingcontest/id/d3b14003c8f5baa385e7bac9cfc8afed.pdf",
          },
        ],
      },
      pdfList: [],
      select: 0,
      videoList_A: [
        {
          id: 1,
          title: "《父亲》",
          url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-03/c78b57c83c20e9683111ce45336001f4.mp4",
        },
        {
          id: 2,
          title: "《我爱这土地》",
          url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-03/06da65cf7038f12b7facaafbd87db326.mp4",
        },
        {
          id: 3,
          title: "《水调歌头·明月几时有》",
          url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-03/c8387be6d1b4deb44a7df5a0d40d4333.mp4",
        },
      ],
      videoList_B: [
        {
          id: 4,
          title: "《面朝大海，春暖花开》",
          url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-03/f1f2e8d39d3250a757147cfa1060e0a3.mp4",
        },
        {
          id: 5,
          title: "《再别康桥》",
          url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-03/62da6c1b4290a094043fbef5d6a2666c.mp4",
        },
        {
          id: 6,
          title: "《沁园春·雪》",
          url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-03/fd2d666ac3e7f1e0c2ab72b2963440b3.mp4",
        },
      ],
      videoList_C: [
        {
          id: 7,
          title: "《热爱生命》",
          url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-03/55721cf0d201e25d4c743712b48b2ca6.mp4",
        },
        {
          id: 8,
          title: "《你是人间的四月天》",
          url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-03/d4dfbc7c59d085cebce350721edf4cee.mp4",
        },
        {
          id: 9,
          title: "《将进酒》",
          url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-03/33402f8deea06a2fb0b3fe2c2aa9d83e.mp4",
        },
      ],
    };
  },
  computed: {},
  components: {
    headers,
  },
  // watch: {
  //   select(val){
  //     if(val){
  //       this.anshow = false;
  //       console.log(val);
  //       this.pdfList = [];
  //       this.pdfList = this.pdf[`new${val}`];
  //       this.anshow = true;
  //     }
  //   }
  // },
  created() {
    this.pdfList = this.pdf[`new0`];
  },
  mounted() {},
  methods: {
    getPdf(e) {
      this.$axios({
        url: e.url,
        method: "get",
        responseType: "blob",
      })
        .then((response) => {
          this.$toast.clear();
          this.$toast.success("開始下載");
          // 将文件流转化为 Blob 对象，并创建 a 标签进行下载
          const blob = new Blob([response.data], { type: "application/pdf" });
          const downloadElement = document.createElement("a");
          const href = window.URL.createObjectURL(blob); // 创建下载链接
          downloadElement.href = href;
          downloadElement.download = e.name; // 文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 下载
          document.body.removeChild(downloadElement); // 下载完成后移除元素
          window.URL.revokeObjectURL(href); // 释放占用的内存空间
        })
        .catch((error) => {
          this.$toast.clear();
          console.error(error); // 处理异常情况
        });
    },
    pdfBut(e) {
      // this.$dialog
      //   .alert({
      //     title: '提示',
      //     message: '誦材暫未開放下載',
      //     confirmButtonText: '確認'
      //   })
      //   .then(() => {
      //     // on close
      //   })

      if (e.url) {
        // this.getPdf(e);
        window.open(e.url, "_blank");
      } else {
        this.$dialog
          .alert({
            title: "提示",
            message: "決賽誦材暫未開放下載",
            confirmButtonText: "確認",
          })
          .then(() => {
            // on close
          });
      }
    },
    tabBut(e) {
      this.select = e;
      this.pdfList = this.pdf[`new${e}`];
    },
  },
};
</script>

<style lang="scss" scoped>
.views {
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  background: #ff782f;

  .posters {
    width: 100%;
    display: flex;
    position: relative;

    img {
      width: 100%;
    }

    .posters_ewm {
      position: absolute;
      width: 1024px;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: right;

      .ewm {
        width: 161px;
        height: 189px;
        background: rgba(255, 255, 255, 0.63);
        border-radius: 16px 16px 16px 16px;
        padding: 8px;
        box-sizing: border-box;

        .ewm2 {
          width: 100%;
          height: 100%;
          padding: 6px;
          background: #fdcf1d;
          border-radius: 12px 12px 12px 12px;
          box-sizing: border-box;

          .ewm3 {
            width: 132px;
            height: 132px;
            background: #ffffff;
            border-radius: 8px 8px 8px 8px;
            margin-bottom: 6px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .ewm3_value {
            font-size: 16px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #323232;
            line-height: 19px;
            text-align: center;
          }
        }
      }
    }
  }

  .content {
    width: 100%;
    margin: auto;

    .viewsBoxTab {
      width: 100%;
      position: relative;
      background: #d34a00;

      .viewsTab {
        width: 100%;
        max-width: 1024px;
        margin: auto;
        box-sizing: border-box;
        display: flex;

        ul {
          width: 100%;
          height: 64px;
          display: inline-flex;
          justify-content: center;
          align-items: center;

          li {
            width: 190px;
            height: 100%;
            display: flex;
            align-content: center;
            align-items: center;
            flex-wrap: wrap;
            font-family: PingFang SC-Semibold, PingFang SC;
            line-height: 20px;
            flex: 0 0 auto;
            background: #d34a00;
            cursor: pointer;

            div {
              width: 100%;
            }

            div:nth-child(1) {
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
            }

            div:nth-child(2) {
              font-size: 11px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
            }
          }

          .select {
            font-size: 16px;
            font-weight: 600;
            color: #903300;
            padding: 8px 0;
            background: url("~@/assets/image/hodgepodge/tabbuttom.png")
              no-repeat;
            background-size: 100% 100%;

            div:nth-child(1) {
              font-size: 16px !important;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600 !important;
              color: #903300;
            }

            div:nth-child(2) {
              font-size: 13px !important;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600 !important;
              color: #903300;
            }
          }
        }
      }
    }

    .viewsList {
      width: 100%;
      max-width: 1024px;
      margin: 64px auto 50px auto;
      padding: 0.32rem;
      box-sizing: border-box;

      ul {
        width: 100%;

        li {
          width: 640px;
          height: 124px;
          margin: auto;
          background: #fff8de;
          box-shadow: 0px 0px 4px 0px rgba(126, 56, 0, 0.26);
          border: 4px solid #fff0e1;
          border-radius: 16px;
          margin-bottom: 32px;
          font-size: 24px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ff782f;
          line-height: 28px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }
    }
  }
}
.viewBoxContent {
  max-width: 1240px;
  margin: auto;
  margin-top: 104px;

  .box_uls {
    width: 964px;
    min-height: 314px;
    margin: auto;
    box-sizing: border-box;
    border-image-source: url("~@/assets/image/hodgepodge/pcbeij.png");
    border-image-slice: 84 10 10 10;
    border-image-width: 67px 9px 9px 9px;
    border-width: 9px;
    padding: 0 10px 10px 10px;
    box-sizing: border-box;
    .container {
      background: #ffffff;
      position: relative;
      border-radius: 12px;
      .item {
        padding: 20px 0;
        .item_title {
          display: block;
          min-width: 160px;
          max-width: 90%;
          height: 36px;
          background: #ff9003;
          box-shadow: 0px 0px 7px 0px rgba(249, 118, 47, 0.3);
          border-radius: 18px;
          border: 2px solid #ffffff;
          padding: 7px 24px;
          box-sizing: border-box;
          font-size: 18px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          margin: 0 auto 16px auto;
          text-align: center;
          display: inline-block;
        }
      }
      .item:last-child {
        padding-bottom: 30px;
      }
    }
    .box_title {
      width: 100%;
      box-sizing: border-box;
      margin: auto;
      position: relative;

      img {
        // width: 100%;
        height: 118.8px;
        margin-top: -6.1%;
        // object-fit: none;
      }
      .title {
        position: absolute;
        top: -36px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 30px;
        font-weight: bold;
        color: #fff;
        // text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        text-shadow: -1px -1px 0 #ff782f, 1px -1px 0 #ff782f, -1px 1px 0 #ff782f,
          1px 1px 0 #ff782f;
        width: 70%;
      }
    }
  }
}
</style>
